import React from 'react';

import { useHttpStatus } from '~/commons/hooks';

import Html from '~/commons/components/Html.jsx';
import Modal from '~/commons/components/Modal.jsx';

const ModalConfirmLogin = ({
  show = false,
  allow,
  onHide = () => {},
}) => {
  const [, logoutReq] = useHttpStatus();
  const logout = () => logoutReq({
    url: 'api/core/auth/logout?web=1',
  });

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onHide();
          logout();
        }}
        centered
        className="p-4"
      >
        <div className="mb-4">
          <Html>{allow?.msg || ''}</Html>
        </div>
        {allow?.login ? (
          <div className="form-row">
            <div className="col">
              <button
                className="btn btn-block btn-outline-warning"
                onClick={() => {
                  onHide();
                  logout();
                }}
              >
                取消登入
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-block btn-warning"
                onClick={() => {
                  window.location.replace('app');
                }}
              >
                同意並登入
              </button>
            </div>
          </div>
        ) : (
          <button
            className="btn btn-primary btn-block"
            onClick={() => onHide()}
          >
            OK
          </button>
        )}
      </Modal>
    </>
  );
};

export default ModalConfirmLogin;
